import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import Symbols from '../../../common/assets/symbols'

class TitleCard extends Component {
	constructor(props) {
		super(props)

		this.state = {
			viewable: false,
		}
	}

	render() {
		const {
			title,
		} = this.props

		if (!title) {
			return null
		}

		const {
			name,
			artworkUrls,
			meta,
			synopsis,
		} = title

		const skatersList = meta.skaters.map((skater, index, array) => {
	    const trailingComma = index !== array.length - 1 ? ', ' : ''

	    return `${skater.name}${trailingComma}`
	  })

	  const directorsList = meta.directors.map((director, index, array) => {
	    const trailingComma = index !== array.length - 1 ? ', ' : ''

	    return `${director.name}${trailingComma}`
	  })

	  const brandsList = meta.brands.map((brand, index, array) => {
	    const trailingComma = index !== array.length - 1 ? ', ' : ''

	    return `${brand.name}${trailingComma}`
	  })

	  const genresList = meta.genres.map((genre, index, array) => {
	    const trailingComma = index !== array.length - 1 ? ', ' : ''

	    return `${genre.name}${trailingComma}`
	  })

	  const styles = {
	  	backdrop: {
        opacity: this.props.show ? '1' : '0',
        visibility: this.props.show ? 'visible' : 'hidden',
      },
	  	content: {
	  		transform: this.props.show ? 'translate3d(-100%,0,0)' : 'translate3d(0,0,0)',
	  	},
	  }

		return (
			<div className="title-card">
				<div className="title-card__backdrop" style={styles.backdrop} />
				<div className="title-card__content" style={styles.content}>
					<div className="title-card__cover">
						<img className="title-card__image" alt="" src={artworkUrls.poster} />
						<div className="title-card__overlay title-card__overlay--disabled" />
						<div className="title-card__gradient title-card__gradient--disabled" />
						<Link className="title-card__play-button" to="/watch/9380">
							<span className="title-card__play-icon" />
						</Link>
					</div>
					<div className="title-card__overview">
						<h3 className="title-card__name">{name}</h3>
						<p className="title-card__specs">{`${meta.year} ${meta.duration} minutes`}</p>
						<p className="title-card__synopsis">{synopsis}</p>
						<div className="title-card__meta">
							<p className="title-card__meta-item">
								<span className="title-card__meta-label">Skaters:</span>
								<span className="title-card__meta-value">{skatersList}</span>
							</p>
							<p className="title-card__meta-item">
								<span className="title-card__meta-label">Directors:</span>
								<span className="title-card__meta-value">{directorsList}</span>
							</p>
							<p className="title-card__meta-item">
								<span className="title-card__meta-label">Brands:</span>
								<span className="title-card__meta-value">{brandsList}</span>
							</p>
							<p className="title-card__meta-item">
								<span className="title-card__meta-label">Genres:</span>
								<span className="title-card__meta-value">{genresList}</span>
							</p>
							<div style={{ height: '32px', }} />
						</div>
					</div>
					<div className="title-card__close-button" onClick={this.props.hide}>
						<div className="title-card__close-icon">{Symbols.back}</div>
					</div>
				</div>
			</div>
		)
	}
}

export default TitleCard


// WEBPACK FOOTER //
// ./src/mobile/components/title-card/index.js